import { CustomCellRendererProps } from 'ag-grid-react'

import {
  BARRIER_TYPE_LABELS,
  BarrierType,
} from '@/pages/instruments/new-instrument/constants/barrier-types'

export interface BarrierTypeCellRendererProps extends CustomCellRendererProps {
  value: BarrierType
}

export const BarrierTypeCellRenderer: React.FC<BarrierTypeCellRendererProps> = ({ value }) => {
  const label = BARRIER_TYPE_LABELS[value]

  return <>{label}</>
}
